"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _passwordRulesModule = _interopRequireDefault(require("./password-rules.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getConfig = function getConfig(maxLength) {
  return [{
    desc: 'length',
    match: new RegExp("^.{8,".concat(maxLength, "}$")),
    messaging: "8 - ".concat(maxLength, " Characters")
  }, {
    desc: 'contains-number',
    match: /\d{1}/,
    messaging: '1 Number'
  }, {
    desc: 'contains-one-uppercase-letter',
    match: /[A-Z]{1}/,
    messaging: '1 Uppercase letter'
  }, {
    desc: 'contains-one-lowercase-letter',
    match: /[a-z]{1}/,
    messaging: '1 Lowercase letter'
  }];
};
var PasswordRules = function PasswordRules(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$touched = _ref.touched,
    touched = _ref$touched === void 0 ? false : _ref$touched,
    _ref$maxLength = _ref.maxLength,
    maxLength = _ref$maxLength === void 0 ? 20 : _ref$maxLength;
  var rules = getConfig(maxLength).map(function (rule) {
    var ruleValid = rule.match.test(value);
    var className = (0, _classnames["default"])(_defineProperty(_defineProperty(_defineProperty({}, _passwordRulesModule["default"].valid, ruleValid), _passwordRulesModule["default"].invalid, !ruleValid), _passwordRulesModule["default"].touched, touched));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
      className: className,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        children: rule.messaging
      })
    }, rule.desc);
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": "password-rules",
    "data-jlds": true,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: _passwordRulesModule["default"].visuallyHiddenText,
      "data-testid": "password-rules-a11y-text",
      children: ["Password needs at least: 8 to ", maxLength, " characters. 1 number. 1 uppercase letter. 1 lowercase letter. Security tip: Avoid using common words such as Password1."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _passwordRulesModule["default"].wrapper,
      "data-testid": "rules-container",
      "aria-hidden": "true",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        "data-testid": "password-rules-hints",
        children: rules
      })
    })]
  });
};
PasswordRules.propTypes = {
  value: _propTypes["default"].string,
  touched: _propTypes["default"].bool,
  maxLength: _propTypes["default"].number
};
var _default = exports["default"] = PasswordRules;